import css from './NumericalDisplay.module.scss';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";

var NumericalDisplay = function NumericalDisplay(_ref) {
  var count = _ref.count,
      type = _ref.type;
  var text = count === 1 ? "".concat(count, " ").concat(type) : "".concat(count, " ").concat(type, "s");
  return /*#__PURE__*/_jsx("span", {
    className: css.root,
    children: text
  });
};

NumericalDisplay.propTypes = {
  count: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
};
export default NumericalDisplay;